import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import EntityTypeName from '../EntityTypeName';

// Selectors
import { makeSelectWorkTypeValue } from '../../services/workTypes/selectors';

interface Props {
    entityTypeId?: ?number;
}

export class WorkTypeEntityTypeName extends React.PureComponent<Props> {
    render() {
        const { entityTypeId } = this.props;
        if (!entityTypeId) return null;
        return <EntityTypeName entityTypeId={entityTypeId} />;
    }
}

const mapStateToProps = createStructuredSelector({
    entityTypeId: makeSelectWorkTypeValue('entityTypeId')
});

export default connect(mapStateToProps)(WorkTypeEntityTypeName);
